import axios from 'axios'

const SET_LOADING = 'SET_LOADING'

function initialState() {
  return {
    imports: [],
    importsList: [],
    loading: {
      imports: false,
    },
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async getImports({
      commit,
    }, roleMapId) {
      commit(SET_LOADING, {
        imports: true,
      })

      try {
        let res = await axios.get('api/Imports/HomePage?tenantId=' + roleMapId)
        let mapped = res.data.map(x => {
          return {
            id: x.Id,
            filename: x.Filename,
            status: x.Status,
            media_type: x.MediaType,
            created_at: x.CreatedAt,
            start_station: x.StartStation,
            end_station: x.EndStation,
            start_analyte: x.StartAnalyte,
            end_analyte: x.EndAnalyte,
            start_data: x.StartData,
            end_data: x.EndData,
            coc_code: x.CocCode,
            analytesCount: x.AnalytesCount,
            stationsCount: x.StationsCount,
            dataCount: x.DataCount,
            mediaTypesCount: x.MediaTypesCount,
            serviceName: 'A125 Data',
            isSuccess: true,
            isTestRun: false,
          }
        })

        commit('SET_IMPORTS', mapped)
      } catch (e) {
        throw 'Failed to fetch import details.'
      }

      commit(SET_LOADING, {
        imports: false,
      })
    },
    // Deprecated
    async getImportsList({
      commit,
    }, importViewModel) {
      commit(SET_LOADING, {
        imports: true,
      })
      try {
        let res = await axios.get('api/Imports/List?tenantId=' + importViewModel.TenantId + '&startDate=' + importViewModel.StartDate + '&endDate=' + importViewModel.EndDate)
        let mapped = res.data.map(x => {
          return {
            id: x.Id,
            filename: x.Filename,
            status: x.Status,
            media_type: x.MediaType,
            created_at: x.CreatedAt,
            start_station: x.StartStation,
            end_station: x.EndStation,
            start_analyte: x.StartAnalyte,
            end_analyte: x.EndAnalyte,
            start_data: x.StartData,
            end_data: x.EndData,
            coc_code: x.CocCode,
            analytesCount: x.AnalytesCount,
            stationsCount: x.StationsCount,
            dataCount: x.DataCount,
            mediaTypesCount: x.MediaTypesCount,
            executionId: x.ExecutionId,
            serviceName: 'A125 Data',
            isSuccess: true,
            isTestRun: false,
          }
        })
        let imports = JSON.parse(JSON.stringify(mapped))
        let i = 0
        imports.forEach(element => {
          element.dateSort = i++
        })

        commit('SET_IMPORTSLIST', imports)
      } catch (e) {
        throw 'Failed to fetch list of imports.'
      }

      commit(SET_LOADING, {
        imports: false,
      })
    },
    async fetchImport(_, {
      importId,
      tenantId,
    }) {
      try {
        let res = await axios.get(`api/Imports/Detail/${importId}`, {
          params: {
            tenantId,
          },
        })
        return res.data
      } catch (error) {
        throw error.response.data
      }
    },
    async fetchImportByExecutionId(_, {
      executionId,
      tenantId,
    }) {
      try {
        let res = await axios.get(`api/Imports/Execution/${executionId}`, {
          params: {
            tenantId,
          },
        })
        return res.data
      } catch (error) {
        throw error.response.data
      }
    },
    async rollback({
      dispatch,
    }, {
      importId,
    }) {
      let res
      try {
        res = await axios.delete('api/Imports/Rollback', {
          data: {
            importId,
          },
        })

        const a = dispatch('monitoringfeature/fetchMonitoringFeaturesUI', {}, { root: true })
        const b = dispatch('navigation/fetchSideMenu', {}, { root: true })
        await Promise.all([a, b])

        return res.data
      } catch (error) {
        throw error.response.data.Message
      }
    },
  },

  mutations: {
    [SET_LOADING](state, value) {
      state.loading = {
        ...state.loading,
        ...value,
      }
    },
    SET_IMPORTS(s, v) {
      s.imports = v
    },
    SET_IMPORTSLIST(s, v) {
      s.importsList = v
    },
    RESET(state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },

  getters: {
    imports: s => s.imports,
    importlist: s => s.importsList,
    currentImport: s => s.currentImport,
    loadingImports: s => s.loading.imports,
  },
}